import { Button } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { OptModelTypeEnum } from '../../../components/YHDict/Types'
import { YHDict } from '../../../components/YHDict'
import { FormItemTypeEnum, IFormItem, IYhFormRef } from '../../../components/YhFormBox/Types'
import { branchDs } from '../../../utils/constants'
import { useOrgModel } from './orgModel'
import { orgService } from './orgService'
import { globalPrompt } from '../../../components/YhMessage'
import { YhAuth } from '@/components/auth/YhAuth'
import { ResourceAuthEnum } from '@/types/FmsResourceAuthEnum'

export const BaseOrg = () => {
  const formRef = useRef<IYhFormRef>()
  const {
    selectedData,
    selectedRowKeys,
    syncData,
    getTreeData,
    dataSource,
    optModelType,
    setSelectedRowKeys,
    setSelectParentData,
    setSelectedData,
    setOptModelType,
    loadData,
    // loadOneData,
  } = useOrgModel()

  useEffect(() => {
    loadData()
  }, [])

  // const [peerAndSon, setPeerAndSon] = useState(-1)
  // useEffect(() => {
  //   formRef.current?.resetFields();
  //   setPeerAndSon(optModelType)
  // }, [selectedData])

  const items: IFormItem[] = [
    {
      type: FormItemTypeEnum.Select,
      fieldLabel: "分支",
      fieldName: "branch",
      ds: branchDs,
      span: 13,
    },
    {
      type: FormItemTypeEnum.Input,
      fieldLabel: "版本",
      fieldName: "ver",
      span: 13,
      disable: true,
    },
    {
      type: FormItemTypeEnum.Switch,
      fieldLabel: "启用",
      fieldName: "enable",
      valuePropName: "checked",
      span: 13,
    },
    {
      type: FormItemTypeEnum.Input,
      fieldLabel: "从属机构",
      fieldName: "pcode",
      span: 13,
      hidden: !selectedData?.pcode,
    },
    {
      type: FormItemTypeEnum.Input,
      fieldLabel: "编码",
      fieldName: "code",
      span: 13,
    },
    {
      type: FormItemTypeEnum.Input,
      fieldLabel: "名称",
      fieldName: "name",
      span: 13,
    },
    {
      type: FormItemTypeEnum.Input,
      fieldLabel: "联系人",
      fieldName: "contact",
      span: 13,
    },
    {
      type: FormItemTypeEnum.Input,
      fieldLabel: "联系电话",
      fieldName: "phone",
      span: 13,
    },
    {
      type: FormItemTypeEnum.Input,
      fieldLabel: "联系地址",
      fieldName: "address",
      span: 13,
    },
    {
      type: FormItemTypeEnum.Input,
      fieldLabel: "备注",
      fieldName: "note",
      span: 13,
    }
  ]

  const action = <>
    {/* <Button
      className="mr-5"
      type="link"
      shape="round"
      disabled={selectedRowKeys.length === 0}
      onClick={() => onAddPeer()}
    >增加同级</Button>
    <Button
      className="mr-5"
      type="link"
      shape="round"
      disabled={selectedRowKeys.length === 0}
      onClick={() => onAddSon()}
    >增加下级</Button>
    <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => remove()}
        >删除</Button> */}
    <YhAuth resCode={ResourceAuthEnum.DATA_ORG_REFRESH}>
      <Button
        className="mr-5"
        type="link"
        shape="round"
        onClick={loadData}
      >刷新</Button>
    </YhAuth>
    <YhAuth resCode={ResourceAuthEnum.DATA_ORG_SYNC}>
      <Button
        className="mr-5"
        type="link"
        shape="round"
        onClick={syncData}
      >同步</Button>
    </YhAuth>
  </>


  const onAddPeer = () => { }

  const onAddSon = () => { }


  const onSubmit = async () => {
    try {
      // const formData = await formRef.current?.validateFields();
      // if (formData) {
      //   const params = {
      //     ...formData,
      //     enable: formData.enable ? 1 : 0,
      //   }
      //   if (optModelType === OptModelTypeEnum.ADD_ROOT || optModelType === OptModelTypeEnum.ADD_CHILD_LEVEL) {
      //     const insertRet = await orgService.insert(params);
      //     if (insertRet.success) {
      //       await globalPrompt("message", { type: "success", text: '新增成功!' });
      //       await loadData();
      //     } else {
      //       await globalPrompt("message", { type: "error", text: "修改失败!" + insertRet.retMsg });
      //     }
      //   }
      //   if (optModelType === OptModelTypeEnum.DETAIL) {
      //     const updateRet = await orgService.update(params);
      //     if (updateRet.success) {
      //       await globalPrompt("message", { type: "success", text: '修改成功!' });
      //       await loadData();
      //     } else {
      //       await globalPrompt("message", { type: "error", text: "修改失败!" + updateRet.retMsg });
      //     }
      //   }
      // }
    } catch (e) {
      console.log("失败!");
    }
  }

  const onCancel = () => {

  }

  const onReset = () => {
    // formRef.current?.resetFields()
  }

  const onSelect = (selectedKeys: React.Key[], info: any) => {
    const selectedNode = info.selectedNodes[0];
    const pNode = dataSource.find(item => item.code === selectedNode?.pcode)
    setSelectParentData(pNode)
    setSelectedData(selectedNode.el)
    setSelectedRowKeys(selectedKeys)
    setOptModelType(OptModelTypeEnum.DETAIL)
  }

  return (
    <YHDict
      // form
      items={items}
      optModelType={optModelType}
      onSubmit={onSubmit}
      onCancel={onCancel}
      onReset={onReset}
      initialValues={{
        ...selectedData,
        enable: selectedData?.enable === 1
      }}
      formRef={formRef}
      disabled={true}

      // tree
      action={action}
      treeData={getTreeData()}
      onSelect={onSelect}
    />
  )
}